/**
 * Admin Users — Actions Configuration
 * CRUD flags, detail page actions, and bulk actions.
 */

import type { DetailAction } from "@/components/shared/UniversalDetailPage/types/action-types";
import type { BaseEntity } from "@/components/shared/UniversalCRMTable/types/base-types";

export const adminUserActions = {
  create: true,
  edit: true,
  delete: true,
  view: true,
};

export const adminUserDetailActions: DetailAction<BaseEntity>[] = [
  {
    id: "grant-employee-access",
    label: "Grant Employee Access",
    icon: "Users",
    variant: "default" as const,
    action: "grantEmployeeAccess",
  },
  {
    id: "grant-client-access",
    label: "Grant Client Access",
    icon: "Shield",
    variant: "default" as const,
    action: "grantClientAccess",
  },
  {
    // Lend YOUR Google Drive connection to a Drive-less admin. WTC admins have no
    // Google identity of their own (internal email), so this borrow model is the
    // only way they can browse Drive. See GOOGLE_DRIVE_ACCESS_DELEGATION.
    id: "grant-drive-access",
    label: "Grant Google Drive Access",
    icon: "HardDrive",
    variant: "default" as const,
    action: "grantDriveAccess",
    visible: (item) => (item as { role?: string }).role === "wtc_admin",
  },
  {
    id: "edit",
    label: "Edit",
    icon: "Edit",
    variant: "default" as const,
  },
  {
    id: "delete",
    label: "Delete",
    icon: "Trash2",
    variant: "destructive" as const,
  },
];

export const adminUserBulkActions = [
  {
    id: "bulk_delete",
    label: "Delete Selected",
    icon: "Trash2",
    variant: "destructive" as const,
  },
  {
    id: "bulk_export",
    label: "Export to CSV",
    icon: "Download",
    variant: "default" as const,
  },
  {
    id: "bulk_email",
    label: "Send Email",
    icon: "Mail",
    variant: "default" as const,
  },
];
